import { useReducer, useCallback } from 'react';
const DEFAULT_OPTIONS = {
    resetOnReload: false,
    initialLoading: false,
};
export default (promiseAction, partialArgs = {}, partialOpts = {}) => {
    const opts = {
        ...DEFAULT_OPTIONS,
        ...partialOpts,
    };
    const dispatcher = promiseAction.dispatcher('PENDING', 'SUCCESS', 'ERROR', partialArgs);
    function reducer(state, action) {
        switch (action.type) {
            case 'PENDING':
                return {
                    loading: true,
                    data: opts.resetOnReload ? undefined : state.data,
                    error: opts.resetOnReload ? undefined : state.error,
                    successful: opts.resetOnReload ? undefined : state.successful,
                };
            case 'SUCCESS':
                return {
                    ...state,
                    loading: false,
                    data: action.payload,
                    successful: true,
                };
            case 'ERROR':
                return {
                    ...state,
                    loading: false,
                    error: action.payload,
                    successful: false,
                };
        }
    }
    const [state, dispatch] = useReducer(reducer, { loading: opts.initialLoading });
    const run = useCallback((args) => dispatcher(args)(dispatch), [dispatcher, dispatch]);
    return ({
        run,
        ...state,
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlTGF6eUFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvaG9va3MvdXNlTGF6eUFjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLFdBQVcsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQW1CaEQsTUFBTSxlQUFlLEdBQVk7SUFDL0IsYUFBYSxFQUFFLEtBQUs7SUFDcEIsY0FBYyxFQUFFLEtBQUs7Q0FDdEIsQ0FBQTtBQUVELGVBQWUsQ0FDYixhQUErQyxFQUMvQyxjQUFxRCxFQUFFLEVBQ3ZELGNBQWdDLEVBQUUsRUFDWSxFQUFFO0lBQ2hELE1BQU0sSUFBSSxHQUFZO1FBQ3BCLEdBQUcsZUFBZTtRQUNsQixHQUFHLFdBQVc7S0FDZixDQUFDO0lBQ0YsTUFBTSxVQUFVLEdBQUcsYUFBYSxDQUFDLFVBQVUsQ0FDekMsU0FBUyxFQUNULFNBQVMsRUFDVCxPQUFPLEVBQ1AsV0FBVyxDQUNaLENBQUM7SUFFRixTQUFTLE9BQU8sQ0FBQyxLQUF5QixFQUFFLE1BQXlDO1FBQ25GLFFBQU8sTUFBTSxDQUFDLElBQUksRUFBRTtZQUNsQixLQUFLLFNBQVM7Z0JBQ1osT0FBTztvQkFDTCxPQUFPLEVBQUUsSUFBSTtvQkFDYixJQUFJLEVBQUUsSUFBSSxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsSUFBSTtvQkFDakQsS0FBSyxFQUFFLElBQUksQ0FBQyxhQUFhLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEtBQUs7b0JBQ25ELFVBQVUsRUFBRSxJQUFJLENBQUMsYUFBYSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxVQUFVO2lCQUM5RCxDQUFDO1lBQ0osS0FBSyxTQUFTO2dCQUNaLE9BQU87b0JBQ0wsR0FBRyxLQUFLO29CQUNSLE9BQU8sRUFBRSxLQUFLO29CQUNkLElBQUksRUFBRSxNQUFNLENBQUMsT0FBTztvQkFDcEIsVUFBVSxFQUFFLElBQUk7aUJBQ2pCLENBQUM7WUFDSixLQUFLLE9BQU87Z0JBQ1YsT0FBTztvQkFDTCxHQUFHLEtBQUs7b0JBQ1IsT0FBTyxFQUFFLEtBQUs7b0JBQ2QsS0FBSyxFQUFFLE1BQU0sQ0FBQyxPQUFPO29CQUNyQixVQUFVLEVBQUUsS0FBSztpQkFDbEIsQ0FBQTtTQUNKO0lBQ0gsQ0FBQztJQUVELE1BQU0sQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLEdBQUcsVUFBVSxDQUFDLE9BQU8sRUFBRSxFQUFFLE9BQU8sRUFBRSxJQUFJLENBQUMsY0FBYyxFQUFFLENBQUMsQ0FBQztJQUNoRixNQUFNLEdBQUcsR0FBRyxXQUFXLENBQUMsQ0FBQyxJQUE2QixFQUFFLEVBQUUsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxVQUFVLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQztJQUUvRyxPQUFPLENBQUM7UUFDTixHQUFHO1FBQ0gsR0FBRyxLQUFLO0tBQ1QsQ0FBQyxDQUFDO0FBQ0wsQ0FBQyxDQUFDIn0=